import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Option {
  text: string;
  value: number;
}

interface Props {
  options: Option[];
  selectedValue: number;
  setSelected: (value: number) => void;
}

const SlidingSelect = ({ options, selectedValue, setSelected }: Props) => {
  const selectedIndex = options.findIndex((option) => option.value === selectedValue);
  const optionWidth = `calc(${100 / options.length}% - 4px)`;
  const optionHeight = `calc(100% - 8px)`;

  return (
    <div className="tw-relative tw-flex tw-bg-transparent-light-200 tw-rounded tw-overflow-hidden tw-p-1">
      <div
        className="tw-absolute tw-bg-neutral-600 tw-rounded tw-transition-all tw-duration-300"
        style={{
          width: optionWidth,
          height: optionHeight,
          transform: `translateX(calc(${(100 / options.length) * 2} * ${selectedIndex}%))`,
        }}
      />
      {options.map((option) => (
        <Button
          key={option.value}
          size="small"
          variant={ButtonVariant.bare}
          className={classNames(
            'tw-flex-1 tw-z-10 tw-transition-all',
            option.value === selectedValue ? 'tw-text-white' : 'tw-text-neutral-400',
          )}
          onClick={() => setSelected(option.value)}
          aria-current={option.value === selectedValue ? 'true' : 'false'}
        >
          {option.text}
        </Button>
      ))}
    </div>
  );
};

export default SlidingSelect;
